import Button from '@/components/DesignLibrary/Button';

type Props = {
  onClick: () => void;
};

const RemoveButton: React.FC<Props> = ({ onClick }) => (
  <Button
    variant="destructive"
    size="md"
    onClick={onClick}
  >
      Remove
  </Button>
);

export default RemoveButton;